import { render, staticRenderFns } from "./BsTab.vue?vue&type=template&id=41190c9b&scoped=true&"
import script from "./BsTab.vue?vue&type=script&lang=js&"
export * from "./BsTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41190c9b",
  null
  
)

export default component.exports